import {observer} from "mobx-react";
import {useStore} from "../../../../../../../hooks";
import Alerts from "../../../../../../../elements/v2/Alerts/Alerts";
import {MarketingErrorMessages} from "../../../../../../../utils/enums";
import React from "react";

export const MissingSegmentAlert = observer(() => {
  const { marketingStore } = useStore();
  const { alert } = marketingStore;
  
  return (
    <>
      {alert.showMissingSegment && (
        <Alerts
          severity={"error"}
          width={"auto"}
          top={"61px"}
          right={"16px"}
          title={MarketingErrorMessages.MESSAGE_TAB.title}
          message={MarketingErrorMessages.MESSAGE_TAB.message}
          onClose={() => alert.hide("showMissingSegment")}
        />
      )}
    </>
  );
});
